import {Id, toast, ToastActions, ToastOptions} from 'vue3-toastify';


// To keep track of the currently active toast ID
let activeToastId: string | Id | null = null;

export async function ErrorToast(e: any, isTypeBlob = false, t?: any) {
    
    if (e.status === 505) {
        return;
    }

    // Dismiss the currently active toast, if any
    if (activeToastId) {
        ToastActions.dismiss(activeToastId);
    }

    const blobMessage = isTypeBlob && JSON.parse(await e?.response?.data?.text());

    let errorMessages = blobMessage?.message ??
        (e?.response?.data?.error?.message ?
            e?.response?.data?.error?.message :
            ['Ein Fehler ist aufgetreten und dein Daten konnten nicht gespeichert ' +
            'werden.Versuche es bitte noch ein Mal. Sollte der Fehler erneut auftreten, ' +
            'dann kontaktier bitte sofort Mirco Siegmund erkläre im Detail wie der Fehler entstanden ist.']
        );

    const isMessageArray = isErrorArray(errorMessages);

    if (isMessageArray) {
        errorMessages?.forEach((errorMessage: string, index: number) => {
            !!errorMessage?.length && toast.error(errorMessage, {toastId: `${errorMessage}-${index}`});
        });
    } else {
        if (t) {
            errorMessages = t('general.toasts.' + errorMessages);
        }

        const defaultOptions: ToastOptions = {
            autoClose: true,          // Prevent auto-close by default
            hideProgressBar: false,    // Show progress bar
            progress: 1,               // Full progress bar
            position: 'top-center',    // Default position
            closeOnClick: true,        // Allow close on click
            style: {width: '550px', height: '100px', fontSize: '16px'}
        };

        activeToastId = toast.error(errorMessages, defaultOptions);
    }
}

export function SuccessToast(props: string, options?: ToastOptions) {

    // Dismiss the currently active toast, if any
    if (activeToastId) {
        ToastActions.dismiss(activeToastId);
    }

    const defaultOptions: ToastOptions = {
        autoClose: true,          // Prevent auto-close by default
        hideProgressBar: false,    // Show progress bar
        progress: 1,               // Full progress bar
        position: 'top-center',    // Default position
        closeOnClick: true,        // Allow close on click
        style: {width: '500px', height: '100px', fontSize: '16px'}
    };

    // Merge provided options with the defaults
    const mergedOptions = {...defaultOptions, ...options};

    if (options && options.progress == 0) {
        delete mergedOptions.progress;
    }
    activeToastId = toast.success(props, mergedOptions);
}

export function WarningToast(props: string, options?: ToastOptions) {
    toast.warning(props, options);
}

const isErrorArray = (args: string[]) => {
    return Array.isArray(args);
}

export function CloseToast() {
    if (activeToastId) {
        ToastActions.dismiss(activeToastId);
        activeToastId = null; // Reset the active toast ID
    }
}
